import { Directive, TemplateRef, AfterViewInit, Input, inject } from '@angular/core';
import { ZefSnackTemplateService } from './snack-template.service';
import { ZefSnackType } from './snack.model';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[zefSnackOutlet]',
  standalone: false,
})
export class ZefSnackOutletDirective implements AfterViewInit {

  templateRef = inject(TemplateRef<any>);
  #snackTemplate = inject(ZefSnackTemplateService);

  @Input()
  zefSnackOutletType: ZefSnackType;

  ngAfterViewInit() {
    this.#snackTemplate.setTemplate(
      this.templateRef,
      this.zefSnackOutletType
    );
  }
}
